import { CSVTextEntry } from '../../../FilterResultsManager/components';
import { TextEntryFilterOption } from '../../../FilterResultsManager/options/types';

export const config: TextEntryFilterOption = {
  id: 'jaxGeneDrugEvidence.filters.efficacyEvidence',
  title: {
    id: 'jaxGeneDrugEvidence.filters.efficacyEvidence',
    defaultMessage: 'Efficacy Evidence',
  },
  content: CSVTextEntry,
  injectedProps: {
    searchKey: '~efficacy_evidence',
    textEntryOption: {
      id: 'jaxGeneDrugEvidence.filters.efficacyEvidence',
      searchValue: '',
      placeholderIntlLabel: {
        id: 'jaxGeneDrugEvidence.filters.efficacyEvidence.placeholder',
        defaultMessage: 'Efficacy Evidence',
      },
    },
  },
};
